import { render, staticRenderFns } from "./CausesExacerbationsDictionary.vue?vue&type=template&id=49ff80a0&lang=pug&"
import script from "./CausesExacerbationsDictionary.vue?vue&type=script&lang=js&"
export * from "./CausesExacerbationsDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports